import classNames from 'classnames';
import React from 'react';
import styles from './page-table-container.module.scss';

interface Props {
    children: React.ReactNode;
    className?: string;
}

export default function PageTableContainer({ children, className }: Props) {
    return (
        <div className={classNames(styles.tableContainer, className)}>
            {children}
        </div>
    );
}
